export default __webpack_public_path__ + "static/media/a001-02.15bde37e.svg";